<template>
  <div>
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"
              class="workflow-tabs">
              <input type="hidden" name="_token" :value="csrf">
              <input v-if="this.editing" type="hidden" name="_method" value="PUT">


              <div class="tab-content">

                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.title") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.description") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[description]"
                        :value="this.description">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.sorting") }}</label>
                      <input type="number" class="form-control rounded" name="questionBase[sorting]"
                        :value="this.sorting">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <div class="form-group">
                        <label> {{
                          __('forms.EvaluationChart.questions.questions_setting.xlsx.questions.question22.typeInputCareer')
                          }} </label>
                        <select class="form-control rounded" name="questionSettings[typeInputCareer]"
                          v-model="typeInputCareer">
                          <option value="checkbox">Checkbox</option>
                          <option value="radio">Radiobutton</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __('forms.EvaluationChart.questions.questions_setting.xlsx.questions.question22.careers') }}
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="row align-items-center" v-for="(row, index) in careers" :key="'careers_' + index">

                      <div class="col-4" v-for="(locale, indexLocale) in locales" :key="'locale_career_' + indexLocale">
                        <label>
                          {{ __('forms.EvaluationChart.questions.questions_setting.xlsx.questions.question22.career') }}
                          {{ locale }}
                        </label>
                        <input class="form-control rounded" type="text"
                          :name="'questionSettings[careers][' + index + '][' + locale + ']'" required :value="row[locale]">
                      </div>
                      <div class="col-1">
                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right"
                          @click="deleteCareer(index)"><i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2"><label>{{ __('forms.EvaluationChart.questions.questions_setting.xlsx.questions.question22.add_career') }}</label></p>
                  </div>
                </div>
                <div class="row align-items-end">
                  <div class="col-3">
                    <label>Carriera</label>
                    <input class="form-control" type="text" v-model="career">
                  </div>
                  <div class="col-3">
                    <button type="button" class="btn float-right" @click="addCareer()">
                      {{  __('misc.add') }}
                    </button>
                  </div>
                </div>


                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                  </div>
                </div>

              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {

  props: {
    can_write: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {

      typeInputCareer: "checkbox",
      careers: [],
      locales: [],
      career: "",
      //default
      title: "Careers",
      active: false,
      action: "",
      name: "",
      description: "",
      sorting: -1,
      editing: true,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {


    deleteCareer(rowIndex) {
      Vue.delete(this.careers, rowIndex);
    },

    addCareer() {

      if (this.career !== "") {
        let newCareer = {};
        this.locales.forEach((locale) => {
          newCareer[locale] = this.career;
        });
        this.careers.push(newCareer);
        this.career = "";
      }

    },

    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;

      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);

        }
        axios.get(dataRoute)
          .then((response) => {

            this.name = response.data.base.name;
            this.description = response.data.base.description;
            this.sorting = response.data.base.sorting;
            this.locales = response.data.locales;
            this.careers = response.data.careers;
            this.typeInputCareer = response.data.typeInputCareer;
            this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
          });
      }
    }

  }

}
</script>
